import React, { Component } from "react";
import * as FlexLayout from "flexlayout-react";
import CommodityClasses from "./commodityClasses";
import CommodityClasse from "./commodityClass";
import { withTranslation } from "react-i18next";

class CommodityClasseAdmin extends Component {
  LAYOUT = {
    global: {
      minWidth: 100,
      minHeight: 100,
    },
    borders: [],
    layout: {
      type: "row",
      children: [
        {
          type: "tabset",
          weight: 50,
          enableMaximize: false,
          children: [
            {
              type: "tab",
              name: this.props.t("CommodityClasses"),
              enableClose: false,
              component: "CommodityClasses",
            },
          ],
        },
        {
          //Figure out how to make this persistent even when empty.
          type: "tabset",
          id: "1",
          weight: 50,
          enableDeleteWhenEmpty: false,
          enableMaximize: false,
          children: [
            // {
            //   type: "tab",
            //   name: "User",
            //   visible: false,
            //   component: "Placeholder"
            // }
          ],
        },
      ],
    },
  };

  state = {
    model: FlexLayout.Model.fromJson(this.LAYOUT),
  };

  handleCommodityClasseSelect = (
    CommodityClasse,
    submitCallbackFunction,
    isNew
  ) => {
    const { commodityClassId, name } = CommodityClasse;

    try {
      this.state.model.doAction(
        FlexLayout.Actions.addNode(
          {
            type: "tab",
            component: "CommodityClasse",
            name: `${name}`,
            id: `${commodityClassId}`,
            config: { commodityClassId, submitCallbackFunction, isNew },
          },
          "1",
          FlexLayout.DockLocation.CENTER,
          0,
          true
        )
      );
    } catch {
      this.state.model.doAction(FlexLayout.Actions.selectTab(commodityClassId));
    }
  };

  handleTabRename = (nodeId, name) => {
    this.state.model.doAction(
      FlexLayout.Actions.updateNodeAttributes(nodeId, { name: name })
    );
  };

  factory = (node) => {
    const componentId = node.getComponent();
    //const CommodityClasseId = node.getId();

    if (componentId === "CommodityClasses") {
      return (
        <CommodityClasses
          onClick={this.handleCommodityClasseSelect}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "CommodityClasse") {
      const { commodityClassId, submitCallbackFunction, isNew } =
        node.getConfig();
      return (
        <CommodityClasse
          commodityClassId={commodityClassId}
          submitCallbackFunction={submitCallbackFunction}
          isNew={isNew}
          onRename={this.handleTabRename}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "Placeholder") {
      return <div></div>;
    } else {
      return null;
    }
  };

  buildFlexLayout = () => {
    return (
      <div className="flex-container">
        <FlexLayout.Layout model={this.state.model} factory={this.factory} />;
      </div>
    );
  };

  render() {
    return this.buildFlexLayout();
  }
}

export default withTranslation(["products"])(CommodityClasseAdmin);
